// Copyright (c) 2023, Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'
import useDeleteComment from './hooks/useDeleteComment'

const DeleteComment = props => {
  const handleDeleteComment = useDeleteComment(props)

  return (
    <i
      className={'fa fa-trash margin-left-half pointer text-red'}
      id={`${props.idRoot}-trigger`}
      style={{ fontSize: '1.5em' }}
      onClick={handleDeleteComment} />
  )
}

DeleteComment.propTypes = {
  idRoot: string.isRequired,
}

export default DeleteComment
